(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-personalizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('swj-personalizer')) {
    class SwjPersonalizer extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.tabs = [...this.querySelectorAll('[data-step-tab]')];
        this.current = 0;
        this.bypass = false;

        this.steps.slice(0, -1).forEach((step, i) => {
          if (step.querySelector('[data-next]')) return;
          const next = document.createElement('button');
          next.type = 'button';
          next.className = 'swj-pp__next';
          next.setAttribute('data-next', '');
          next.textContent = (this.dataset.nextLabel || 'Next step') + ' →';
          next.addEventListener('click', () => {
            this.tryGoTo(i + 1);
            if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          step.appendChild(next);
        });
        this.querySelector('[data-save-next]')?.addEventListener('click', (e) => this.saveAndNext(e.currentTarget));
        this.savedModal = this.querySelector('[data-saved-modal]');
        if (this.savedModal) {
          this.savedModal.addEventListener('click', (e) => { if (e.target === this.savedModal) this.savedModal.close(); });
          this.savedModal.querySelector('[data-design-next]')?.addEventListener('click', () => {
            this.savedModal.close();
            this.resetDesign();
          });
        }
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.tryGoTo(+tab.dataset.stepTab)));

        this.querySelectorAll('.swj-dd').forEach((dd) => this.initDropdown(dd));
        this.onDocClick = (e) => {
          this.querySelectorAll('.swj-dd.is-open').forEach((dd) => { if (!dd.contains(e.target)) this.closeDropdown(dd); });
        };
        document.addEventListener('click', this.onDocClick);

        this.petCount = this.querySelector('[data-pet-count]');
        if (this.petCount) this.petCount.addEventListener('change', () => this.updatePets());

        this.querySelectorAll('[data-tip]').forEach((btn) => btn.addEventListener('click', (e) => {
          e.preventDefault();
          const next = btn.nextElementSibling;
          const box = next && next.classList.contains('swj-pp__tiptext') ? next : btn.closest('.swj-pp__field')?.querySelector('.swj-pp__tiptext');
          if (box) box.hidden = !box.hidden;
        }));

        this.querySelectorAll('input[data-reveal]').forEach((r) => r.addEventListener('change', () => this.updateReveal(r.dataset.reveal)));
        this.querySelectorAll('input[type="file"]').forEach((input) => input.addEventListener('change', () => this.onFile(input)));

        this.addEventListener('change', (e) => {
          e.target.closest('.swj-pp__field')?.classList.remove('is-invalid');
          this.updateExtra();
        });
        this.addEventListener('input', (e) => e.target.closest('.swj-pp__field')?.classList.remove('is-invalid'));

        this.updatePets();
        ['sleeve', 'extra'].forEach((k) => this.updateReveal(k));
        this.updateExtra();
        this.attachToForm();
      }

      disconnectedCallback() {
        if (this.boundSubmit) window.removeEventListener('submit', this.boundSubmit, true);
        if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
        this.ready = false;
      }

      /* ---------- custom colour dropdowns ---------- */
      initDropdown(dd) {
        const input = dd.querySelector('input[type="hidden"]');
        const btn = dd.querySelector('.swj-dd__btn');
        const list = dd.querySelector('.swj-dd__list');
        const items = [...list.querySelectorAll('[role="option"]')];
        const pick = (li) => {
          items.forEach((o) => o.setAttribute('aria-selected', o === li ? 'true' : 'false'));
          input.value = li.dataset.value;
          const icon = btn.querySelector('[data-icon]');
          const liIcon = li.querySelector('.swj-dd__icon');
          if (icon && liIcon) {
            icon.innerHTML = liIcon.innerHTML;
            icon.className = liIcon.className;
            icon.setAttribute('data-icon', '');
          }
          btn.style.setProperty('--c', li.style.getPropertyValue('--c'));
          btn.querySelector('[data-text]').textContent = (li.querySelector('[data-name]') || li).textContent.trim();
          dd.closest('.swj-pp__field')?.classList.remove('is-invalid');
        };
        const initial = items.find((o) => o.dataset.value === input.value) || items[0];
        if (initial) pick(initial);

        btn.addEventListener('click', () => (dd.classList.contains('is-open') ? this.closeDropdown(dd) : this.openDropdown(dd)));
        items.forEach((li) => li.addEventListener('click', () => { pick(li); this.closeDropdown(dd); btn.focus(); }));
        dd.addEventListener('keydown', (e) => {
          const open = dd.classList.contains('is-open');
          if (e.key === 'Escape' && open) { e.preventDefault(); this.closeDropdown(dd); btn.focus(); return; }
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter' && e.key !== ' ') return;
          if (!open) { if (e.key !== 'Enter' && e.key !== ' ') { e.preventDefault(); this.openDropdown(dd); } return; }
          e.preventDefault();
          let i = items.findIndex((o) => o.classList.contains('is-focus'));
          if (e.key === 'Enter' || e.key === ' ') { if (items[i]) pick(items[i]); this.closeDropdown(dd); btn.focus(); return; }
          i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
          items.forEach((o, n) => o.classList.toggle('is-focus', n === i));
          items[i].scrollIntoView({ block: 'nearest' });
        });
      }

      openDropdown(dd) {
        this.querySelectorAll('.swj-dd.is-open').forEach((o) => o !== dd && this.closeDropdown(o));
        dd.classList.add('is-open');
        dd.querySelector('.swj-dd__list').hidden = false;
        dd.querySelector('.swj-dd__btn').setAttribute('aria-expanded', 'true');
        const items = [...dd.querySelectorAll('[role="option"]')];
        items.forEach((o) => o.classList.toggle('is-focus', o.getAttribute('aria-selected') === 'true'));
      }

      closeDropdown(dd) {
        dd.classList.remove('is-open');
        dd.querySelector('.swj-dd__list').hidden = true;
        dd.querySelector('.swj-dd__btn').setAttribute('aria-expanded', 'false');
      }

      /* ---------- save design & start the next one ---------- */
      async saveAndNext(btn, goCart = false) {
        const err = this.querySelector('.swj-pp__form-error');
        const bad = this.firstInvalidStep();
        if (bad !== -1) {
          this.show(bad);
          this.validateStep(bad);
          if (err) err.hidden = false;
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (!this.form) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          const pid = 'P' + Date.now().toString(36).toUpperCase();
          this.querySelector('[data-pid]').value = pid;
          const data = new FormData(this.form);
          const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          if (!res.ok) throw new Error('add');
          const addons = this.selectedAddons();
          if (addons.length) {
            const qty = +(data.get('quantity') || 1);
            await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: addons.map((a) => ({ id: +a.id, quantity: qty, properties: { _Linked: pid } })) }),
            });
          }
          const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble && icon.renderCartBubble(cart.item_count));
          if (err) err.hidden = true;
          if (goCart) { window.location.href = root + 'cart'; return; } if (this.savedModal && this.savedModal.showModal) this.savedModal.showModal();
          else this.resetDesign();
        } catch (e) {
          if (err) err.hidden = false;
        }
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }

      resetDesign() {
        this.querySelectorAll('input[type="text"], input[type="number"]').forEach((el) => (el.value = ''));
        this.querySelectorAll('input[type="file"]').forEach((el) => { el.value = ''; this.onFile(el); });
        this.querySelectorAll('input[data-reveal]').forEach((el) => (el.checked = false));
        this.querySelectorAll('input[type="checkbox"]').forEach((el) => (el.checked = el.defaultChecked));
        if (this.petCount) this.petCount.selectedIndex = 0;
        this.querySelectorAll('[data-pid]').forEach((el) => (el.value = ''));
        this.updatePets();
        ['sleeve', 'extra'].forEach((k) => this.updateReveal(k));
        this.updateExtra();
        this.querySelectorAll('.is-invalid').forEach((f) => f.classList.remove('is-invalid'));
        this.show(0);
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      /* ---------- form wiring ---------- */
      attachToForm(tries = 0) {
        const scope = this.closest('.shopify-section') || document;
        const form = document.getElementById(this.dataset.formId) || scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        if (!form) {
          if (tries < 20) setTimeout(() => this.attachToForm(tries + 1), 250);
          return;
        }
        if (!form.id) form.id = 'swj-form-' + Math.random().toString(36).slice(2);
        this.form = form;
        form.setAttribute('enctype', 'multipart/form-data');
        this.querySelectorAll('input[name],select[name],textarea[name]').forEach((el) => el.setAttribute('form', form.getAttribute('id')));
        if (!this.boundSubmit) {
          this.boundSubmit = (e) => this.onSubmit(e);
          window.addEventListener('submit', this.boundSubmit, true);
        }
      }

      petTotal() {
        const opt = this.petCount?.selectedOptions[0];
        return +(opt?.dataset.count || 1);
      }

      updatePets() {
        const n = this.petTotal();
        this.querySelectorAll('[data-pets-min]').forEach((el) => {
          const on = +el.dataset.petsMin <= n;
          el.hidden = !on;
          el.querySelectorAll('input,select,textarea').forEach((f) => (f.disabled = !on));
          if (!on) el.classList.remove('is-invalid');
        });
        this.querySelectorAll('[data-when-single]').forEach((el) => (el.hidden = n > 1));
        this.querySelectorAll('[data-when-multi]').forEach((el) => (el.hidden = n <= 1));
        this.updateExtra();
      }

      updateReveal(key) {
        const target = this.querySelector('[data-revealed="' + key + '"]');
        if (!target) return;
        const checked = this.querySelector('input[data-reveal="' + key + '"]:checked');
        const on = !!checked && !checked.hasAttribute('data-off');
        target.hidden = !on;
        target.querySelectorAll('input,select,textarea').forEach((f) => (f.disabled = !on));
        if (!on) target.classList.remove('is-invalid');
      }

      onFile(input) {
        const wrap = input.closest('.swj-pp__upload');
        const img = wrap.querySelector('.swj-pp__preview');
        const name = wrap.querySelector('.swj-pp__filename');
        const file = input.files[0];
        if (!file) { img.hidden = true; name.textContent = ''; return; }
        if (file.size > 20 * 1024 * 1024) {
          input.value = '';
          name.textContent = 'Max. 20 MB';
          img.hidden = true;
          return;
        }
        name.textContent = file.name;
        if (file.type.startsWith('image/')) {
          if (img.src) URL.revokeObjectURL(img.src);
          img.src = URL.createObjectURL(file);
          img.hidden = false;
        }
      }

      /* ---------- add-on pricing ---------- */
      selectedAddons() {
        const out = [];
        const opt = this.petCount?.selectedOptions[0];
        if (opt?.dataset.addon) out.push({ id: opt.dataset.addon, price: +opt.dataset.price || 0 });
        this.querySelectorAll('input[data-addon]:checked').forEach((el) => {
          if (!el.disabled) out.push({ id: el.dataset.addon, price: +el.dataset.price || 0 });
        });
        return out;
      }

      updateExtra() {
        const box = this.querySelector('.swj-pp__extra');
        if (!box) return;
        const total = this.selectedAddons().reduce((s, a) => s + a.price, 0);
        box.hidden = total === 0;
        if (total) {
          let txt;
          try {
            txt = new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(total / 100);
          } catch (e) { txt = (total / 100).toFixed(2); }
          box.querySelector('[data-extra-total]').textContent = txt;
        }
      }

      /* ---------- validation & steps ---------- */
      validateStep(index) {
        const step = this.steps[index];
        if (!step) return true;
        let ok = true;
        step.querySelectorAll('.swj-pp__field[data-required]').forEach((field) => {
          if (field.hidden || field.closest('[hidden]:not([data-step])')) return;
          let valid = true;
          const kind = field.dataset.kind;
          if (kind === 'radio') {
            valid = !!field.querySelector('input[type="radio"]:checked');
          } else if (kind === 'file') {
            const f = field.querySelector('input[type="file"]');
            valid = !f || f.disabled || f.files.length > 0;
          } else {
            const el = field.querySelector('input:not([type="hidden"]),select,textarea') || field.querySelector('input');
            if (el && !el.disabled) {
              const v = el.value.trim();
              valid = v !== '';
              if (valid && kind === 'year') {
                const y = +v;
                valid = Number.isInteger(y) && y >= +el.min && y <= +el.max;
              }
            }
          }
          field.classList.toggle('is-invalid', !valid);
          if (!valid) ok = false;
        });
        return ok;
      }

      firstInvalidStep() {
        for (let i = 0; i < this.steps.length; i++) if (!this.validateStep(i)) return i;
        return -1;
      }

      tryGoTo(target) {
        if (target < 0 || target >= this.steps.length) return;
        if (target > this.current) {
          for (let i = this.current; i < target; i++) {
            if (!this.validateStep(i)) { this.show(i); return; }
          }
        }
        this.show(target);
      }

      show(index) {
        this.current = index;
        this.steps.forEach((s, i) => (s.hidden = i !== index));
        this.tabs.forEach((t, i) => {
          t.classList.toggle('is-active', i === index);
          t.classList.toggle('is-done', i < index);
        });
        const err = this.querySelector('.swj-pp__form-error');
        if (err) err.hidden = true;
      }

      async onSubmit(e) {
        if (!this.form || e.target !== this.form) return;
        if (this.bypass) { this.bypass = false; return; } if (this.firstInvalidStep() === -1) { e.preventDefault(); e.stopImmediatePropagation(); this.saveAndNext(e.submitter || this.form.querySelector('[type="submit"]'), true); return; }

        const err = this.querySelector('.swj-pp__form-error');
        const bad = this.firstInvalidStep();
        if (bad !== -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.show(bad);
          this.validateStep(bad);
          if (err) err.hidden = false;
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }

        const pid = 'P' + Date.now().toString(36).toUpperCase();
        this.querySelector('[data-pid]').value = pid;

        const addons = this.selectedAddons();
        if (!addons.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        const qty = +(new FormData(this.form).get('quantity') || 1);
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: addons.map((a) => ({ id: +a.id, quantity: qty, properties: { _Linked: pid } })),
            }),
          });
          if (!res.ok) throw new Error('addon');
        } catch (error) {
          if (err) err.hidden = false;
          return;
        }
        this.bypass = true;
        const submitter = e.submitter || this.form.querySelector('[type="submit"]');
        this.form.requestSubmit(submitter && submitter.form === this.form ? submitter : undefined);
      }
    }
    customElements.define('swj-personalizer', SwjPersonalizer);
  }
  } catch(e) { console.error(e); }
})();

})();
